import { ReactElement, ReactNode, forwardRef } from 'react';
import cn from '../../../../utils/classnames';
import Tooltip from '../../base/tooltip';
import { TooltipProps } from '../../base/types';
import './simple-tooltip.scss';

export type SimpleTooltipProps = TooltipProps & { children: ReactNode };

const SimpleTooltip = forwardRef<HTMLDivElement, SimpleTooltipProps>((props, ref): ReactElement => {
    const { children, className, ...rest } = props;

    if (!children) {
        return <></>;
    }

    const classNames = cn('simple-tooltip', className);

    return (
        <Tooltip ref={ref} className={classNames} {...rest}>
            {children}
        </Tooltip>
    );
});

SimpleTooltip.displayName = 'SimpleTooltip';

export default SimpleTooltip;
